import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { musinsaSnapClient } from '../musinsaSnapClient';
import { snapLikeApiPath } from './apiPath';

const DeleteSnapLikedRequestSchema = z
  .object({
    snapId: z.string(),
  })
  .describe('DeleteSnapLikedRequestSchema');

const DeleteSnapLikedResponseDataSchema = z
  .object({
    data: z.null().optional(),
  })
  .describe('DeleteSnapLikedResponseDataSchema');

export type DeleteSnapLikedRequest = z.infer<typeof DeleteSnapLikedRequestSchema>;
export type DeleteSnapLikedResponseData = z.infer<typeof DeleteSnapLikedResponseDataSchema>;
export type DeleteSnapLikedResponse = MusinsaStandardResponse<DeleteSnapLikedResponseData>;

export const deleteSnapLiked = (params: DeleteSnapLikedRequest) =>
  executeStandardRequest(() =>
    musinsaSnapClient.delete<DeleteSnapLikedResponse>(snapLikeApiPath.snapLiked(params.snapId)),
  );
